import * as React from 'react';
import { Switch as AntdSwitch } from 'antd';
import { SwitchProps as AntdSwitchProps } from 'antd/lib/switch';
import { AppContext } from '@/utils/appProvider';
import classnames from 'classnames';
import './index.less';

export interface SwitchProps extends AntdSwitchProps {}

const Switch: React.FC<SwitchProps> = props => {
  const { className } = props;
  const { prefixCls } = React.useContext(AppContext);

  return <AntdSwitch {...props} className={classnames(`${prefixCls}-switch`, className)} />;
};

export default Switch;
